export default {
  "pl-PL": {
    "Upload plików": "",
    "Strona została zaktualizowana.": "",
    "Nazwisko": "",
    "Nazwa roli": "",
    "Wymiary": "",
    "Brak strony nadrzędnej": "",
    "pokaż więcej...": "",
    "Utwórz katalog": "",
    "Zabierz dostęp": "",
    "Użytkownik został dodany.": "",
    "Nie": "",
    "Treść została zaktualizowana.": "",
    "Utworzył": "",
    "Usunięcie wybranych elementów": "",
    "Błąd 404. Nie znaleziono żądanego zasobu.": "",
    "Wybrane elementy zostały usunięte.": "",
    "Rozmiar zdjęcia został zmieniony.": "",
    "Nowe hasło": "",
    "Nazwa katalogu została zmieniona.": "",
    "Dodaj wpis": "",
    "Pobierz plik": "",
    "Dokument %0": "",
    "Edycja strony": "",
    "Pliki publiczne": "",
    "Strona główna": "",
    "Usuń plik": "",
    "Standardowa strona": "",
    "Moje dokumenty": "",
    "Publikacja została zmieniona.": "",
    "Zapamiętaj logowanie": "",
    "Tak": "",
    "Wszystkie niezapisane zmiany zostaną utracone.": "",
    "Synchronizuj": "",
    "Dodaj treść": "",
    "Zdjęcie użytkownika": "",
    "Dodanie wpisu": "",
    "Wysokość": "",
    "Publiczne": "",
    "Zdjęcie główne": "",
    "Strona została usunięta.": "",
    "Usuń plik z listy": "",
    "Nazwa": "",
    "Zapisz": "",
    "Edytuj stronę": "",
    "Profil użytkownika": "",
    "Wstaw dwie kolumny 2/3 oraz 1/3": "",
    "Wybierz zaznaczone": "",
    "Nie znaleziono żadnych plików": "",
    "Zaznacz wszystkie": "",
    "Opis": "",
    "Wybrane elementy zostały przeniesione.": "",
    "Treść została dodana.": "",
    "Zmiana rozmiaru obrazu": "",
    "Rola została zaktualizowana.": "",
    "Strony": "",
    "Przeniesienie wybranych elementów": "",
    "Adres URL": "",
    "Wstaw szablon informacyjny ze zdjęciem": "",
    "Filtruj": "",
    "Zwrócony": "",
    "Status dokumentu": "",
    "Dodanie strony": "",
    "Nie wszystkie wybrane elementy zostały przeniesione. Nie posiadasz wymaganych uprawnień lub, w przypadku przenoszenia katalogów, katalog docelowy jest podkatalogiem katalogu źródłowego. Katalogi i pliki których nie udało się przenieść pozostały nadal w zakładce Wybrane.": "",
    "Wybierz plik lub katalog": "",
    "Zmień status": "",
    "Zaakceptowany": "",
    "Typ strony": "",
    "Na pewno usunąć wybrane elementy?": "",
    "Szkic": "",
    "Wykonaj": "",
    "Szerokość": "",
    "Katalog został utworzony.": "",
    "Niestandardowy adres strony": "",
    "Podaj swój adres email": "",
    "Imię": "",
    "Ścieżka": "",
    "Role użytkownika": "",
    "Status": "",
    "E-mail": "",
    "Administratorzy": "",
    "Data od": "",
    "Usuń katalog": "",
    "Powtórz hasło": "",
    "Edycja roli": "",
    "Publikuj od": "",
    "Aktualność została dodana.": "",
    "Zmień rozmiar": "",
    "Rola aktywna": "",
    "Strona została dodana.": "",
    "Usuń": "",
    "Edycja aktualności": "",
    "Repozytorium plików": "",
    "Struktura serwisu": "",
    "Wpis został usunięty.": "",
    "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "",
    "Role": "",
    "Rola została dodana.": "",
    "Brak modułu": "",
    "Moje konto": "",
    "Aktualne hasło": "",
    "Nie udało się pobrać listy ról": "",
    "Wybierz plik": "",
    "Dodanie roli": "",
    "Aby dodawać strony należy najpierw stworzyć nowy katalog.": "",
    "Zresetuj hasło": "",
    "Wstaw trzy kolumny 1/3": "",
    "Zaloguj się": "",
    "Potwierdzenie usunięcia": "",
    "Tytuł": "",
    "Dodaj katalog": "",
    "Resetuj": "",
    "W tym katalogu nie ma jeszcze żadnych stron.": "",
    "Opisy": "",
    "Nie udało się pobrać listy stron": "",
    "Przyznaj dostęp": "",
    "Wybierz język": "",
    "Szukaj...": "",
    "Administracja": "",
    "Dodaj użytkownika": "",
    "Nie wybrano strony": "",
    "Nie zdefiniowano żadnych ról.": "",
    "Strona opublikowana": "",
    "Aktualność została zaktualizowana.": "",
    "Uprawnienia": "",
    "Użytkownicy": "",
    "Do akceptacji": "",
    "Profil został zaktualizowany.": "",
    "Anuluj": "",
    "Przeciągnij i upuść aby posortować pliki": "",
    "Otwórz stronę w nowym oknie": "",
    "Wstaw dwie kolumny 1/3 oraz 2/3": "",
    "Hasło": "",
    "Nie można usunąć swojego konta.": "",
    "Brak wyników": "",
    "Katalog linków": "",
    "Data modyfikacji": "",
    "Rola została usunięta.": "",
    "Nie masz wymaganych uprawnień do wykonania wybranej operacji.": "",
    "Plik wideo": "",
    "Status został zmieniony.": "",
    "Wybrany język": "",
    "Okładka": "",
    "Wybrane pliki": "",
    "Treść": "",
    "Wyszukaj wszędzie": "",
    "Wszystkie": "",
    "Prywatne": "",
    "Nazwa strony": "",
    "Publikuj do": "",
    "Strona ukryta": "",
    "Wystąpił błąd połączenia. Upewnij się że masz włączony internet i spróbuj ponownie.": "",
    "Edytuj obraz": "",
    "Użytkownik posiada pełne uprawnienia": "",
    "Aktualności": "",
    "Edytuj": "",
    "Edycja wpisu": "",
    "Szablon nr 3": "",
    "Edytuj katalog": "",
    "Wyślij link": "",
    "Dodaj nową stronę lub wybierz z menu aby edytować.": "",
    "Katalog": "",
    "Dodaj rolę": "",
    "Adres strony": "",
    "Szczegóły": "",
    "Data rejestracji": "",
    "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "",
    "Użytkownik został zaktualizowany.": "",
    "Strona nadrzędna": "",
    "Link do strony": "",
    "Na pewno przenieść wybrane elementy do bieżącego katalogu?": "",
    "Usuń datę": "",
    "Nazwa katalogu lub pliku": "",
    "Wróć do strony logowania": "",
    "Treść opublikowana": "",
    "Zaloguj się na swoje konto": "",
    "Folder został usunięty.": "",
    "Edycja użytkownika": "",
    "Wybrano 1 plik": "",
    "Edytuj treść": "",
    "Zmień hasło": "",
    "Nie można dodać pliku(ów): \"%0\". Można dodawać tylko pliki typu: \"%1\".": "",
    "Moduł": "",
    "Plik jest wysyłany": "",
    "Ważne informacje": "",
    "Miniaturki": "",
    "Oraz nowe hasło": "",
    "Ok": "",
    "Nazwa katalogu": "",
    "Adres url": "",
    "Adres e-mail potwierdzony": "",
    "Przenieś wybrane": "",
    "Zamiany zostały zapisane.": "",
    "Pliki do wysłania: %0": "",
    "Adres email": "",
    "Link do wybranej strony serwisu": "",
    "Oczekuje na wysłanie": "",
    "Obraz został wycięty.": "",
    "Zmiana hasła": "",
    "Dostęp zabroniony": "",
    "Plik został wysłany": "",
    "Lista plików": "",
    "Przenieś": "",
    "Wyślij": "",
    "Dodanie aktualności": "",
    "Data dodania": "",
    "Szablon": "",
    "Wstaw cztery kolumny 1/4": "",
    "Data do": "",
    "Wyloguj się": "",
    "Symbol strony": "",
    "Moduły": "",
    "Dostęp przyznany": "",
    "Nie udało się wysłać pliku": "",
    "Opublikuj tutaj": "",
    "Powtóz hasło": "",
    "Wstęp": "",
    "Id": "",
    "Tekst alternatywny": "",
    "Wstaw dwie równe kolumny": "",
    "Rozmiar": "",
    "Hasło zostało zmienione.": "",
    "Publikacja": "",
    "Zamknij": "",
    "Wszyscy": "",
    "Wyszukaj...": "",
    "Tytuł strony": "",
    "Zapomniałeś hasła?": "",
    "Wytnij": "",
    "Powrót": "",
    "Zmień nazwę": "",
    "Nazwa użytkownika": "",
    "Zmień nazwę katalogu": "",
    "Nazwa pliku została zmieniona.": "",
    "Zdjęcie": "",
    "Akcje": "",
    "Strony opisowe": "",
    "Wideo": "",
    "Zmodyfikował": "",
    "Wybierz stronę": "",
    "Wybrane": "",
    "Zmień nazwę pliku": "",
    "Szablon nr 2": "",
    "Dodanie użytkownika": "",
    "Niestandardowy adres": "",
    "Logowanie": "",
    "Szablon nr 1": "",
    "Typ mime": "",
    "Użytkownik został usunięty.": "",
    "Dostęp niezdefiniowany": "",
    "Dodaj stronę": "",
    "Nie udało się pobrać listy katalogów": "",
    "Dodanych plików %0 (limit wynosi %1).": "",
    "Niepotwierdzeni": "",
    "Nazwa pliku": "",
    "Link do zewnętrznej strony": "",
    "Zapisz i wróć": "",
    "Usuń wybrane": "",
    "Brak danych.": "",
    "Pliki prywatne": ""
  },
  "en-US": {
    "Upload plików": "",
    "Strona została zaktualizowana.": "",
    "Nazwisko": "",
    "Nazwa roli": "",
    "Wymiary": "",
    "Brak strony nadrzędnej": "",
    "pokaż więcej...": "",
    "Utwórz katalog": "",
    "Zabierz dostęp": "",
    "Użytkownik został dodany.": "",
    "Nie": "",
    "Treść została zaktualizowana.": "",
    "Utworzył": "",
    "Usunięcie wybranych elementów": "",
    "Błąd 404. Nie znaleziono żądanego zasobu.": "",
    "Wybrane elementy zostały usunięte.": "",
    "Rozmiar zdjęcia został zmieniony.": "",
    "Nowe hasło": "",
    "Nazwa katalogu została zmieniona.": "",
    "Dodaj wpis": "",
    "Pobierz plik": "",
    "Dokument %0": "",
    "Edycja strony": "",
    "Pliki publiczne": "",
    "Strona główna": "",
    "Usuń plik": "",
    "Standardowa strona": "",
    "Moje dokumenty": "",
    "Publikacja została zmieniona.": "",
    "Zapamiętaj logowanie": "",
    "Tak": "",
    "Wszystkie niezapisane zmiany zostaną utracone.": "",
    "Synchronizuj": "",
    "Dodaj treść": "",
    "Zdjęcie użytkownika": "",
    "Dodanie wpisu": "",
    "Wysokość": "",
    "Publiczne": "",
    "Zdjęcie główne": "",
    "Strona została usunięta.": "",
    "Usuń plik z listy": "",
    "Nazwa": "",
    "Zapisz": "",
    "Edytuj stronę": "",
    "Profil użytkownika": "",
    "Wstaw dwie kolumny 2/3 oraz 1/3": "",
    "Wybierz zaznaczone": "",
    "Nie znaleziono żadnych plików": "",
    "Zaznacz wszystkie": "",
    "Opis": "",
    "Wybrane elementy zostały przeniesione.": "",
    "Treść została dodana.": "",
    "Zmiana rozmiaru obrazu": "",
    "Rola została zaktualizowana.": "",
    "Strony": "",
    "Przeniesienie wybranych elementów": "",
    "Adres URL": "",
    "Wstaw szablon informacyjny ze zdjęciem": "",
    "Filtruj": "",
    "Zwrócony": "",
    "Status dokumentu": "",
    "Dodanie strony": "",
    "Nie wszystkie wybrane elementy zostały przeniesione. Nie posiadasz wymaganych uprawnień lub, w przypadku przenoszenia katalogów, katalog docelowy jest podkatalogiem katalogu źródłowego. Katalogi i pliki których nie udało się przenieść pozostały nadal w zakładce Wybrane.": "",
    "Wybierz plik lub katalog": "",
    "Zmień status": "",
    "Zaakceptowany": "",
    "Typ strony": "",
    "Na pewno usunąć wybrane elementy?": "",
    "Szkic": "",
    "Wykonaj": "",
    "Szerokość": "",
    "Katalog został utworzony.": "",
    "Niestandardowy adres strony": "",
    "Podaj swój adres email": "",
    "Imię": "",
    "Ścieżka": "",
    "Role użytkownika": "",
    "Status": "",
    "E-mail": "",
    "Administratorzy": "",
    "Data od": "",
    "Usuń katalog": "",
    "Powtórz hasło": "",
    "Edycja roli": "",
    "Publikuj od": "",
    "Aktualność została dodana.": "",
    "Zmień rozmiar": "",
    "Rola aktywna": "",
    "Strona została dodana.": "",
    "Usuń": "",
    "Edycja aktualności": "",
    "Repozytorium plików": "",
    "Struktura serwisu": "",
    "Wpis został usunięty.": "",
    "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "",
    "Role": "",
    "Rola została dodana.": "",
    "Brak modułu": "",
    "Moje konto": "",
    "Aktualne hasło": "",
    "Nie udało się pobrać listy ról": "",
    "Wybierz plik": "",
    "Dodanie roli": "",
    "Aby dodawać strony należy najpierw stworzyć nowy katalog.": "",
    "Zresetuj hasło": "",
    "Wstaw trzy kolumny 1/3": "",
    "Zaloguj się": "",
    "Potwierdzenie usunięcia": "",
    "Tytuł": "",
    "Dodaj katalog": "",
    "Resetuj": "",
    "W tym katalogu nie ma jeszcze żadnych stron.": "",
    "Opisy": "",
    "Nie udało się pobrać listy stron": "",
    "Przyznaj dostęp": "",
    "Wybierz język": "",
    "Szukaj...": "",
    "Administracja": "",
    "Dodaj użytkownika": "",
    "Nie wybrano strony": "",
    "Nie zdefiniowano żadnych ról.": "",
    "Strona opublikowana": "",
    "Aktualność została zaktualizowana.": "",
    "Uprawnienia": "",
    "Użytkownicy": "",
    "Do akceptacji": "",
    "Profil został zaktualizowany.": "",
    "Anuluj": "",
    "Przeciągnij i upuść aby posortować pliki": "",
    "Otwórz stronę w nowym oknie": "",
    "Wstaw dwie kolumny 1/3 oraz 2/3": "",
    "Hasło": "",
    "Nie można usunąć swojego konta.": "",
    "Brak wyników": "",
    "Katalog linków": "",
    "Data modyfikacji": "",
    "Rola została usunięta.": "",
    "Nie masz wymaganych uprawnień do wykonania wybranej operacji.": "",
    "Plik wideo": "",
    "Status został zmieniony.": "",
    "Wybrany język": "",
    "Okładka": "",
    "Wybrane pliki": "",
    "Treść": "",
    "Wyszukaj wszędzie": "",
    "Wszystkie": "",
    "Prywatne": "",
    "Nazwa strony": "",
    "Publikuj do": "",
    "Strona ukryta": "",
    "Wystąpił błąd połączenia. Upewnij się że masz włączony internet i spróbuj ponownie.": "",
    "Edytuj obraz": "",
    "Użytkownik posiada pełne uprawnienia": "",
    "Aktualności": "",
    "Edytuj": "",
    "Edycja wpisu": "",
    "Szablon nr 3": "",
    "Edytuj katalog": "",
    "Wyślij link": "",
    "Dodaj nową stronę lub wybierz z menu aby edytować.": "",
    "Katalog": "",
    "Dodaj rolę": "",
    "Adres strony": "",
    "Szczegóły": "",
    "Data rejestracji": "",
    "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "",
    "Użytkownik został zaktualizowany.": "",
    "Strona nadrzędna": "",
    "Link do strony": "",
    "Na pewno przenieść wybrane elementy do bieżącego katalogu?": "",
    "Usuń datę": "",
    "Nazwa katalogu lub pliku": "",
    "Wróć do strony logowania": "",
    "Treść opublikowana": "",
    "Zaloguj się na swoje konto": "",
    "Folder został usunięty.": "",
    "Edycja użytkownika": "",
    "Wybrano 1 plik": "",
    "Edytuj treść": "",
    "Zmień hasło": "",
    "Nie można dodać pliku(ów): \"%0\". Można dodawać tylko pliki typu: \"%1\".": "",
    "Moduł": "",
    "Plik jest wysyłany": "",
    "Ważne informacje": "",
    "Miniaturki": "",
    "Oraz nowe hasło": "",
    "Ok": "",
    "Nazwa katalogu": "",
    "Adres url": "",
    "Adres e-mail potwierdzony": "",
    "Przenieś wybrane": "",
    "Zamiany zostały zapisane.": "",
    "Pliki do wysłania: %0": "",
    "Adres email": "",
    "Link do wybranej strony serwisu": "",
    "Oczekuje na wysłanie": "",
    "Obraz został wycięty.": "",
    "Zmiana hasła": "",
    "Dostęp zabroniony": "",
    "Plik został wysłany": "",
    "Lista plików": "",
    "Przenieś": "",
    "Wyślij": "",
    "Dodanie aktualności": "",
    "Data dodania": "",
    "Szablon": "",
    "Wstaw cztery kolumny 1/4": "",
    "Data do": "",
    "Wyloguj się": "",
    "Symbol strony": "",
    "Moduły": "",
    "Dostęp przyznany": "",
    "Nie udało się wysłać pliku": "",
    "Opublikuj tutaj": "",
    "Powtóz hasło": "",
    "Wstęp": "",
    "Id": "",
    "Tekst alternatywny": "",
    "Wstaw dwie równe kolumny": "",
    "Rozmiar": "",
    "Hasło zostało zmienione.": "",
    "Publikacja": "",
    "Zamknij": "",
    "Wszyscy": "",
    "Wyszukaj...": "",
    "Tytuł strony": "",
    "Zapomniałeś hasła?": "",
    "Wytnij": "",
    "Powrót": "",
    "Zmień nazwę": "",
    "Nazwa użytkownika": "",
    "Zmień nazwę katalogu": "",
    "Nazwa pliku została zmieniona.": "",
    "Zdjęcie": "",
    "Akcje": "",
    "Strony opisowe": "",
    "Wideo": "",
    "Zmodyfikował": "",
    "Wybierz stronę": "",
    "Wybrane": "",
    "Zmień nazwę pliku": "",
    "Szablon nr 2": "",
    "Dodanie użytkownika": "",
    "Niestandardowy adres": "",
    "Logowanie": "",
    "Szablon nr 1": "",
    "Typ mime": "",
    "Użytkownik został usunięty.": "",
    "Dostęp niezdefiniowany": "",
    "Dodaj stronę": "",
    "Nie udało się pobrać listy katalogów": "",
    "Dodanych plików %0 (limit wynosi %1).": "",
    "Niepotwierdzeni": "",
    "Nazwa pliku": "",
    "Link do zewnętrznej strony": "",
    "Zapisz i wróć": "",
    "Usuń wybrane": "",
    "Brak danych.": "",
    "Pliki prywatne": ""
  }
}